import * as React from "react";
import * as ReactDOM from "react-dom";
import * as styles from "./styles.scss";

export class CardFooter extends React.Component<{}, {}> {
  render() {
    return <div className={styles.cardFooter}>{this.props.children}</div>;
  }
}
